// SWIPER
const coSwiper1 = new Swiper('.co-acne-4-tabs-cell-1 .swiper', {
  effect: "fade",
  slidesPerView: "auto",
  speed: 400,
  preventInteractionOnTransition: true,
  allowTouchMove: false,
  fadeEffect: {
    crossFade: true,
  },
  loop: true,
  pagination: {
    el: '.co-acne-4-tabs-cell-1 .swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
  navigation: {
    nextEl: ".co-acne-4-tabs-cell-1 .swiper-button-next",
    prevEl: ".co-acne-4-tabs-cell-1 .swiper-button-prev",
  },
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
});
// SWIPER
const coSwiper2 = new Swiper('.co-acne-4-tabs-cell-2 .swiper', {
  effect: "fade",
  slidesPerView: "auto",
  speed: 400,
  preventInteractionOnTransition: true,
  allowTouchMove: false,
  fadeEffect: {
    crossFade: true,
  },
  loop: true,
  pagination: {
    el: '.co-acne-4-tabs-cell-2 .swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
  navigation: {
    nextEl: ".co-acne-4-tabs-cell-2 .swiper-button-next",
    prevEl: ".co-acne-4-tabs-cell-2 .swiper-button-prev",
  },
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
});
// SWIPER
const coSwiper3 = new Swiper('.co-acne-4-tabs-cell-3 .swiper', {
  effect: "fade",
  slidesPerView: "auto",
  speed: 400,
  preventInteractionOnTransition: true,
  allowTouchMove: false,
  fadeEffect: {
    crossFade: true,
  },
  loop: true,
  pagination: {
    el: '.co-acne-4-tabs-cell-3 .swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
  navigation: {
    nextEl: ".co-acne-4-tabs-cell-3 .swiper-button-next",
    prevEl: ".co-acne-4-tabs-cell-3 .swiper-button-prev",
  },
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
});
// SWIPER
const coSwiper4 = new Swiper('.co-acne-4-tabs-cell-4 .swiper', {
  effect: "fade",
  slidesPerView: "auto",
  speed: 400,
  preventInteractionOnTransition: true,
  allowTouchMove: false,
  fadeEffect: {
    crossFade: true,
  },
  loop: true,
  pagination: {
    el: '.co-acne-4-tabs-cell-4 .swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
  navigation: {
    nextEl: ".co-acne-4-tabs-cell-4 .swiper-button-next",
    prevEl: ".co-acne-4-tabs-cell-4 .swiper-button-prev",
  },
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
});

// TABS
(function() {
    'use strict';

    // Configuration
    const config = {
        navigationSelector: '.co-acne-tabs-button',
        contentSections: [
            '.co-acne-4-tabs-wrapper',
            '.co-acne-5-tabs-wrapper',
            '.co-acne-6-tabs-wrapper',
            '.co-acne-7-tabs-wrapper'
        ],
        activeClass: 'co-active'
    };

    // Initialize
    function init() {
        const navButtons = document.querySelectorAll(config.navigationSelector);
        
        // Add click listeners to navigation buttons
        navButtons.forEach((button, index) => {
            button.addEventListener('click', function() {
                const tabIndex = parseInt(this.getAttribute('data-tab-index'));
                activateTabCells(tabIndex);
                updateNavigationButtons(this);
            });

            // Keyboard navigation
            button.addEventListener('keydown', function(e) {
                handleKeyboardNavigation(e, index, navButtons);
            });
        });

        // Initialize first tab as active
        activateTabCells(0);
    }

    // Activate tab cells across all sections
    function activateTabCells(tabIndex) {
        config.contentSections.forEach(sectionSelector => {
            const wrapper = document.querySelector(sectionSelector);
            if (!wrapper) return;

            const cells = wrapper.children;
            
            // Remove active class from all cells in this section
            Array.from(cells).forEach(cell => {
                if (cell.classList.contains('section-label')) return; // Skip labels
                cell.classList.remove(config.activeClass);
            });

            // Add active class to the selected cell if it exists
            if (cells[tabIndex]) {
                cells[tabIndex].classList.add(config.activeClass);
            }
        });

        // Announce to screen readers
        announceChange(tabIndex + 1);
    }

    // Update navigation button states
    function updateNavigationButtons(activeButton) {
        const navButtons = document.querySelectorAll(config.navigationSelector);
        
        navButtons.forEach(button => {
            button.classList.remove(config.activeClass);
            button.setAttribute('aria-selected', 'false');
        });

        activeButton.classList.add(config.activeClass);
        activeButton.setAttribute('aria-selected', 'true');
    }

    // Keyboard navigation
    function handleKeyboardNavigation(e, currentIndex, navButtons) {
        let targetIndex = currentIndex;
        
        switch(e.key) {
            case 'ArrowLeft':
            case 'ArrowUp':
                e.preventDefault();
                targetIndex = currentIndex > 0 ? currentIndex - 1 : navButtons.length - 1;
                break;
            case 'ArrowRight':
            case 'ArrowDown':
                e.preventDefault();
                targetIndex = currentIndex < navButtons.length - 1 ? currentIndex + 1 : 0;
                break;
            case 'Home':
                e.preventDefault();
                targetIndex = 0;
                break;
            case 'End':
                e.preventDefault();
                targetIndex = navButtons.length - 1;
                break;
            default:
                return;
        }
        
        navButtons[targetIndex].focus();
        navButtons[targetIndex].click();
    }

    // Screen reader announcement
    function announceChange(tabNumber) {
        const announcement = document.createElement('div');
        announcement.setAttribute('role', 'status');
        announcement.setAttribute('aria-live', 'polite');
        announcement.setAttribute('aria-atomic', 'true');
        announcement.style.position = 'absolute';
        announcement.style.left = '-10000px';
        announcement.textContent = `Tab ${tabNumber} is now active across all sections`;
        
        document.body.appendChild(announcement);
        setTimeout(() => {
            document.body.removeChild(announcement);
        }, 1000);
    }

    // Start when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();

// BEFORE AFTER
(function() {
  function initSliders() {
    document.querySelectorAll('[data-comparison]').forEach(function(el) {
      const overlay = el.querySelector('.image-compare-overlay');
      const slider = el.querySelector('.image-compare-slider');
      const overlayImg = overlay.querySelector('img');
      let isResizing = false;
      let currentPct = 50;

      function updateDimensions() {
        var w = el.offsetWidth + 'px';
        if (overlayImg) overlayImg.style.width = w;
        var wrapper = overlay.firstElementChild;
        if (wrapper) wrapper.style.width = w;
      }

      function setPosition(pct) {
        currentPct = Math.max(0, Math.min(pct, 100));
        overlay.style.width = currentPct + '%';
        slider.style.left = currentPct + '%';
        el.setAttribute('aria-valuenow', Math.round(currentPct));
        el.setAttribute('aria-valuetext', Math.round(currentPct) + ' percent, showing ' + Math.round(currentPct) + '% before and ' + Math.round(100 - currentPct) + '% after');
      }

      function updateFromPointer(x) {
        const rect = el.getBoundingClientRect();
        const position = Math.max(0, Math.min(x - rect.left, rect.width));
        setPosition((position / rect.width) * 100);
      }

      function startResize(e) {
        e.preventDefault();
        isResizing = true;
        const x = e.touches ? e.touches[0].clientX : e.clientX;
        updateFromPointer(x);

        const move = function(e) {
          if (!isResizing) return;
          updateFromPointer(e.touches ? e.touches[0].clientX : e.clientX);
        };
        const end = function() {
          isResizing = false;
          document.removeEventListener('mousemove', move);
          document.removeEventListener('mouseup', end);
          document.removeEventListener('touchmove', move);
          document.removeEventListener('touchend', end);
        };

        document.addEventListener('mousemove', move);
        document.addEventListener('mouseup', end);
        document.addEventListener('touchmove', move);
        document.addEventListener('touchend', end);
      }

      el.addEventListener('keydown', function(e) {
        var step = e.shiftKey ? 10 : 2;
        switch (e.key) {
          case 'ArrowLeft':
          case 'ArrowDown':
            e.preventDefault();
            setPosition(currentPct - step);
            break;
          case 'ArrowRight':
          case 'ArrowUp':
            e.preventDefault();
            setPosition(currentPct + step);
            break;
          case 'Home':
            e.preventDefault();
            setPosition(0);
            break;
          case 'End':
            e.preventDefault();
            setPosition(100);
            break;
        }
      });

      updateDimensions();
      el.addEventListener('mousedown', startResize);
      el.addEventListener('touchstart', startResize);
      window.addEventListener('resize', updateDimensions);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSliders);
  } else {
    initSliders();
  }
})();